import { computed, Injectable } from '@angular/core';
import { ComponentStoreV2Factory } from '../../../../modules/shared/store/common/component-store-v2.factory';
import { TreeNode } from '@openng/optimus-ui/api';
import {
    parseAuditLogHistoryV2,
} from '../../../../modules/shared/components/audit-log-tree-v2/audit-log-tree-v2.parser';

@Injectable()
export class MedicalServiceLogsPageStore extends ComponentStoreV2Factory {

    history = computed<Record<number, TreeNode[]>>(() =>
        parseAuditLogHistoryV2(this.data.getAuditLogs()?.items || []))

}
